var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMouse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C10.0667 22 8.41667 21.3167 7.05 19.95C5.68333 18.5833 5 16.9333 5 15V9C5 7.06667 5.68333 5.41667 7.05 4.05C8.41667 2.68333 10.0667 2 12 2C13.9333 2 15.5833 2.68333 16.95 4.05C18.3167 5.41667 19 7.06667 19 9V15C19 16.9333 18.3167 18.5833 16.95 19.95C15.5833 21.3167 13.9333 22 12 22ZM13 9H17C17 7.8 16.621 6.74167 15.863 5.825C15.1043 4.90833 14.15 4.33333 13 4.1V9ZM7 9H11V4.1C9.85 4.33333 8.89567 4.90833 8.137 5.825C7.379 6.74167 7 7.8 7 9ZM12 20C13.3833 20 14.5627 19.5127 15.538 18.538C16.5127 17.5627 17 16.3833 17 15V11H7V15C7 16.3833 7.48767 17.5627 8.463 18.538C9.43767 19.5127 10.6167 20 12 20Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouse);
export default __webpack_public_path__ + "static/media/mouse.87fd491d04a2330fc8301c931c97b11c.svg";
export { ForwardRef as ReactComponent };